<div class="w-full mx-auto p-5 space-y-6">

  <!-- Header -->
  <div class="flex flex-wrap justify-between items-center gap-4">
    <div>
      <h1 class="text-2xl font-bold text-gray-800">
        {{ view === 'individual' ? 'Movimientos de Cartera - Individuales' : 'Movimientos de Cartera - Corporativos' }}
      </h1>
      <p class="text-gray-500 mt-1">Historial de retiros, reversiones y aplazamientos</p>
    </div>
  </div>

  <!-- Dashboard de metricas -->
  <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
    <div class="bg-gradient-to-br from-red-100 to-red-50 p-4 rounded-xl border border-red-200">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm text-red-600 font-medium">Retiros</p>
          <p class="text-2xl font-bold text-red-800 mt-1">{{ totalWithdrawals }}</p>
          <p class="text-xs text-red-500 mt-1">{{ activeWithdrawals }} activos</p>
        </div>
        <div class="bg-red-600 text-white p-2 rounded-lg">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
          </svg>
        </div>
      </div>
    </div>

    <div class="bg-gradient-to-br from-green-100 to-green-50 p-4 rounded-xl border border-green-200">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm text-green-600 font-medium">Reversiones</p>
          <p class="text-2xl font-bold text-green-800 mt-1">{{ totalReversals }}</p>
        </div>
        <div class="bg-green-600 text-white p-2 rounded-lg">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
          </svg>
        </div>
      </div>
    </div>

    <div class="bg-gradient-to-br from-orange-100 to-orange-50 p-4 rounded-xl border border-orange-200">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm text-orange-600 font-medium">Aplazamientos</p>
          <p class="text-2xl font-bold text-orange-800 mt-1">{{ totalDeferrals }}</p>
          <p class="text-xs text-orange-500 mt-1">{{ activeDeferrals }} activos</p>
        </div>
        <div class="bg-orange-600 text-white p-2 rounded-lg">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M14.25 9v6m-4.5 0V9M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
      </div>
    </div>

    <div class="bg-gradient-to-br from-blue-100 to-blue-50 p-4 rounded-xl border border-blue-200">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm text-blue-600 font-medium">Total Registros</p>
          <p class="text-2xl font-bold text-blue-800 mt-1">{{ totalRecords }}</p>
        </div>
        <div class="bg-blue-600 text-white p-2 rounded-lg">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z" />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!-- Filtros -->
  <div class="flex flex-wrap gap-4 items-center">
    <div class="relative flex-1 min-w-[300px]">
      <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="onFilterChange()"
        [placeholder]="view === 'individual' ? 'Buscar por documento, nombre o proyecto...' : 'Buscar por NIT, empresa o proyecto...'"
        class="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all">
      <svg class="w-5 h-5 absolute left-3 top-2.5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    </div>

    <div class="w-56">
      <p-dropdown [options]="movementTypeOptions" [(ngModel)]="selectedMovementType" (onChange)="onFilterChange()"
        styleClass="w-full" placeholder="Tipo de movimiento" optionLabel="label" optionValue="value"
        [showClear]="true">
      </p-dropdown>
    </div>

    <div class="w-64">
      <p-dropdown [options]="uniqueProjects" [(ngModel)]="selectedProject" (onChange)="onFilterChange()"
        styleClass="w-full" placeholder="Proyecto" optionLabel="name" optionValue="id" [showClear]="true"
        [filter]="true" filterBy="projectId,name">
        <ng-template let-project pTemplate="selectedItem">
          <div class="flex items-center gap-2" *ngIf="project">
            <span class="font-medium text-blue-600">{{ project.projectId }}</span>
            <span>-</span>
            <span>{{ project.name }}</span>
          </div>
        </ng-template>
        <ng-template let-project pTemplate="item">
          <div class="flex items-center gap-2">
            <span class="font-medium text-blue-600">{{ project.projectId }}</span>
            <span>-</span>
            <span>{{ project.name }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>

  <!-- Tabla -->
  <div class="rounded-xl border border-gray-200 shadow-sm overflow-x-auto">
    <table class="w-full">
      <thead class="bg-gray-50">
        <tr>
          <th class="px-4 py-3 text-left text-sm font-medium text-gray-700 cursor-pointer hover:bg-gray-100 select-none transition-colors"
            (click)="onSortChange('id')">
            <div class="flex items-center gap-1">
              ID
              <svg *ngIf="sortBy === 'id'" class="w-4 h-4 transition-transform duration-200"
                [class.rotate-180]="sortDirection === 'asc'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
              <svg *ngIf="sortBy !== 'id'" class="w-4 h-4 text-gray-300" fill="none" stroke="currentColor"
                viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
              </svg>
            </div>
          </th>
          <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Tipo</th>
          <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Inscripcion</th>
          <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">
            {{ view === 'individual' ? 'Participante' : 'Empresa' }}
          </th>
          <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Proyecto</th>
          <th class="px-4 py-3 text-left text-sm font-medium text-gray-700 cursor-pointer hover:bg-gray-100 select-none transition-colors"
            (click)="onSortChange('movementDate')">
            <div class="flex items-center gap-1">
              Fecha
              <svg *ngIf="sortBy === 'movementDate'" class="w-4 h-4 transition-transform duration-200"
                [class.rotate-180]="sortDirection === 'asc'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
              <svg *ngIf="sortBy !== 'movementDate'" class="w-4 h-4 text-gray-300" fill="none" stroke="currentColor"
                viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
              </svg>
            </div>
          </th>
          <th class="px-4 py-3 text-left text-sm font-medium text-gray-700 cursor-pointer hover:bg-gray-100 select-none transition-colors"
            (click)="onSortChange('amount')">
            <div class="flex items-center gap-1">
              Monto
              <svg *ngIf="sortBy === 'amount'" class="w-4 h-4 transition-transform duration-200"
                [class.rotate-180]="sortDirection === 'asc'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
              <svg *ngIf="sortBy !== 'amount'" class="w-4 h-4 text-gray-300" fill="none" stroke="currentColor"
                viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
              </svg>
            </div>
          </th>
          <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Revertido</th>
          <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Acciones</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 bg-white">
        <tr *ngFor="let data of movementsData" class="hover:bg-gray-50 transition">
          <!-- ID -->
          <td class="px-4 py-3 text-sm text-gray-700">{{ data.id }}</td>

          <!-- Tipo de movimiento -->
          <td class="px-4 py-3">
            <span class="px-2 py-1 text-xs font-medium rounded-full"
              [ngClass]="getMovementTypeClass(data.movementType)">
              {{ data.movementTypeDescription || getMovementTypeLabel(data.movementType) }}
            </span>
          </td>

          <!-- Inscripcion ID -->
          <td class="px-4 py-3 text-sm">
            <a *ngIf="view === 'individual'"
              [routerLink]="['/dashboard/enrollments/view-v2', data.enrollmentId]"
              target="_blank"
              class="text-blue-600 hover:text-blue-800 font-medium hover:underline">
              #{{ data.enrollmentId }}
            </a>
            <a *ngIf="view === 'corporate'"
              [routerLink]="['/dashboard/enrollments/corporate/view-v2', data.corporateEnrollmentId]"
              target="_blank"
              class="text-amber-600 hover:text-amber-800 font-medium hover:underline">
              #{{ data.corporateEnrollmentId }}
            </a>
          </td>

          <!-- Participante / Empresa -->
          <td class="px-4 py-3 text-sm text-gray-700">
            <ng-container *ngIf="view === 'individual'">
              <p class="font-medium text-gray-900">{{ data.participantName || 'N/A' }}</p>
              <p *ngIf="data.participantDocument" class="text-xs text-gray-500">{{ data.participantDocument }}</p>
            </ng-container>
            <ng-container *ngIf="view === 'corporate'">
              <p class="font-medium text-gray-900">{{ data.companyName || 'N/A' }}</p>
              <p *ngIf="data.companyDocument" class="text-xs text-gray-500">{{ data.companyDocument }}</p>
            </ng-container>
          </td>

          <!-- Proyecto con nemonico -->
          <td class="px-4 py-3 text-sm text-gray-700">
            <div class="flex items-center gap-2">
              <span *ngIf="data.projectMnemonic" class="px-2 py-0.5 bg-blue-100 text-blue-800 text-xs rounded-full font-medium">
                {{ data.projectMnemonic }}
              </span>
              <span>{{ data.projectName || 'N/A' }}</span>
            </div>
            <div *ngIf="data.targetProjectName" class="flex items-center gap-2 mt-1 text-xs text-gray-400">
              <span>-></span>
              <span *ngIf="data.targetProjectMnemonic" class="px-1.5 py-0.5 bg-gray-100 text-gray-600 rounded-full">
                {{ data.targetProjectMnemonic }}
              </span>
              <span>{{ data.targetProjectName }}</span>
            </div>
          </td>

          <!-- Fecha -->
          <td class="px-4 py-3 text-sm text-gray-500">
            {{ data.movementDate | date:'medium' }}
          </td>

          <!-- Monto afectado -->
          <td class="px-4 py-3 text-sm font-medium text-gray-700">
            {{ formatCurrency(data.totalAffectedAmount) }}
          </td>

          <!-- Revertido -->
          <td class="px-4 py-3">
            <span *ngIf="data.isReverted"
              class="px-2 py-1 text-xs font-medium rounded-full bg-yellow-100 text-yellow-800">
              Si
            </span>
            <span *ngIf="!data.isReverted"
              class="px-2 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-500">
              No
            </span>
          </td>

          <!-- Acciones -->
          <td class="px-4 py-3">
            <div class="flex items-center gap-1">
              <!-- Ver detalle (offcanvas) -->
              <button (click)="openDetail(data)"
                class="text-gray-600 hover:text-gray-800 p-1.5 rounded-md hover:bg-gray-100" title="Ver detalle">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </button>
              <!-- Ir a inscripcion -->
              <a *ngIf="view === 'individual'"
                [routerLink]="['/dashboard/enrollments/view-v2', data.enrollmentId]"
                target="_blank"
                class="text-blue-600 hover:text-blue-800 p-1.5 rounded-md hover:bg-blue-50" title="Ver inscripcion">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                </svg>
              </a>
              <a *ngIf="view === 'corporate'"
                [routerLink]="['/dashboard/enrollments/corporate/view-v2', data.corporateEnrollmentId]"
                target="_blank"
                class="text-amber-600 hover:text-amber-800 p-1.5 rounded-md hover:bg-amber-50" title="Ver inscripcion corporativa">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                </svg>
              </a>
            </div>
          </td>
        </tr>

        <!-- Empty state -->
        <tr *ngIf="movementsData.length === 0">
          <td colspan="9" class="px-4 py-12 text-center text-gray-500">
            <svg class="w-12 h-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
            </svg>
            <p class="text-lg font-medium">No se encontraron movimientos</p>
            <p class="text-sm mt-1">Ajusta los filtros o realiza una nueva busqueda</p>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginador -->
    <div class="mt-4 bg-white rounded-lg border border-gray-200">
      <p-paginator [rows]="pageSize" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 50, 100]"
        (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros">
      </p-paginator>
    </div>
  </div>
</div>

<!-- ==================== OFFCANVAS DETALLE ==================== -->
<div *ngIf="selectedMovement" class="fixed inset-0 z-50 flex justify-end" (click)="closeDetail()">
  <!-- Overlay -->
  <div class="absolute inset-0 bg-black/40 transition-opacity"></div>

  <!-- Panel -->
  <div class="relative w-full max-w-lg bg-white shadow-xl overflow-y-auto animate-slideInRight"
    (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="sticky top-0 z-10 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
      <div>
        <h2 class="text-lg font-bold text-gray-800">Detalle del Movimiento #{{ selectedMovement.id }}</h2>
        <span class="px-2 py-1 text-xs font-medium rounded-full mt-1 inline-block"
          [ngClass]="getMovementTypeClass(selectedMovement.movementType)">
          {{ selectedMovement.movementTypeDescription || getMovementTypeLabel(selectedMovement.movementType) }}
        </span>
      </div>
      <button (click)="closeDetail()"
        class="text-gray-400 hover:text-gray-600 p-2 rounded-lg hover:bg-gray-100 transition">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="px-6 py-5 space-y-6">

      <!-- Informacion General -->
      <div>
        <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">Informacion General</h3>
        <div class="bg-gray-50 rounded-lg p-4 space-y-3">
          <div class="flex justify-between">
            <span class="text-sm text-gray-500">ID Movimiento</span>
            <span class="text-sm font-medium text-gray-900">{{ selectedMovement.id }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-sm text-gray-500">Tipo</span>
            <span class="text-sm font-medium text-gray-900">
              {{ selectedMovement.movementTypeDescription || getMovementTypeLabel(selectedMovement.movementType) }}
            </span>
          </div>
          <div class="flex justify-between">
            <span class="text-sm text-gray-500">Fecha</span>
            <span class="text-sm font-medium text-gray-900">{{ selectedMovement.movementDate | date:'medium' }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-sm text-gray-500">Realizado por</span>
            <span class="text-sm font-medium text-gray-900">{{ selectedMovement.performedBy }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span class="text-sm text-gray-500">Revertido</span>
            <span *ngIf="selectedMovement.isReverted"
              class="px-2 py-1 text-xs font-medium rounded-full bg-yellow-100 text-yellow-800">
              Si (Mov. #{{ selectedMovement.revertedByMovementId }})
            </span>
            <span *ngIf="!selectedMovement.isReverted"
              class="px-2 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-500">No</span>
          </div>
        </div>
      </div>

      <!-- Inscripcion / Participante / Empresa -->
      <div>
        <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">
          {{ view === 'individual' ? 'Inscripcion y Participante' : 'Inscripcion y Empresa' }}
        </h3>
        <div class="bg-gray-50 rounded-lg p-4 space-y-3">
          <div class="flex justify-between">
            <span class="text-sm text-gray-500">ID Inscripcion</span>
            <a *ngIf="view === 'individual'"
              [routerLink]="['/dashboard/enrollments/view-v2', selectedMovement.enrollmentId]"
              target="_blank" class="text-sm font-medium text-blue-600 hover:underline">
              #{{ selectedMovement.enrollmentId }}
            </a>
            <a *ngIf="view === 'corporate'"
              [routerLink]="['/dashboard/enrollments/corporate/view-v2', selectedMovement.corporateEnrollmentId]"
              target="_blank" class="text-sm font-medium text-amber-600 hover:underline">
              #{{ selectedMovement.corporateEnrollmentId }}
            </a>
          </div>

          <!-- Individual -->
          <ng-container *ngIf="view === 'individual'">
            <div class="flex justify-between">
              <span class="text-sm text-gray-500">Participante</span>
              <span class="text-sm font-medium text-gray-900">{{ selectedMovement.participantName || 'N/A' }}</span>
            </div>
            <div *ngIf="selectedMovement.participantDocument" class="flex justify-between">
              <span class="text-sm text-gray-500">Documento</span>
              <span class="text-sm font-medium text-gray-900">{{ selectedMovement.participantDocument }}</span>
            </div>
            <div *ngIf="selectedMovement.participantEmail" class="flex justify-between">
              <span class="text-sm text-gray-500">Email</span>
              <span class="text-sm font-medium text-gray-900">{{ selectedMovement.participantEmail }}</span>
            </div>
          </ng-container>

          <!-- Corporate -->
          <ng-container *ngIf="view === 'corporate'">
            <div class="flex justify-between">
              <span class="text-sm text-gray-500">Empresa</span>
              <span class="text-sm font-medium text-gray-900">{{ selectedMovement.companyName || 'N/A' }}</span>
            </div>
            <div *ngIf="selectedMovement.companyDocument" class="flex justify-between">
              <span class="text-sm text-gray-500">NIT</span>
              <span class="text-sm font-medium text-gray-900">{{ selectedMovement.companyDocument }}</span>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Proyecto -->
      <div>
        <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">Proyecto</h3>
        <div class="bg-gray-50 rounded-lg p-4 space-y-3">
          <div class="flex justify-between items-center">
            <span class="text-sm text-gray-500">Proyecto</span>
            <div class="flex items-center gap-2">
              <span *ngIf="selectedMovement.projectMnemonic"
                class="px-2 py-0.5 bg-blue-100 text-blue-800 text-xs rounded-full font-medium">
                {{ selectedMovement.projectMnemonic }}
              </span>
              <span class="text-sm font-medium text-gray-900">{{ selectedMovement.projectName || 'N/A' }}</span>
            </div>
          </div>
          <div *ngIf="selectedMovement.targetProjectName" class="flex justify-between items-center">
            <span class="text-sm text-gray-500">Proyecto destino</span>
            <div class="flex items-center gap-2">
              <span *ngIf="selectedMovement.targetProjectMnemonic"
                class="px-2 py-0.5 bg-green-100 text-green-800 text-xs rounded-full font-medium">
                {{ selectedMovement.targetProjectMnemonic }}
              </span>
              <span class="text-sm font-medium text-gray-900">{{ selectedMovement.targetProjectName }}</span>
            </div>
          </div>
          <div *ngIf="selectedMovement.targetEnrollmentId || selectedMovement.targetCorporateEnrollmentId"
            class="flex justify-between">
            <span class="text-sm text-gray-500">Inscripcion destino</span>
            <span class="text-sm font-medium text-blue-600">
              #{{ selectedMovement.targetEnrollmentId || selectedMovement.targetCorporateEnrollmentId }}
            </span>
          </div>
        </div>
      </div>

      <!-- Impacto financiero -->
      <div>
        <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">Impacto Financiero</h3>
        <div class="bg-gray-50 rounded-lg p-4 space-y-3">
          <div class="flex justify-between">
            <span class="text-sm text-gray-500">Monto afectado</span>
            <span class="text-sm font-bold text-gray-900">{{ formatCurrency(selectedMovement.totalAffectedAmount) }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-sm text-gray-500">Cuotas afectadas</span>
            <span class="text-sm font-medium text-gray-900">{{ selectedMovement.affectedInstallmentsCount }}</span>
          </div>
        </div>
      </div>

      <!-- Razon y notas -->
      <div>
        <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">Razon y Notas</h3>
        <div class="bg-gray-50 rounded-lg p-4 space-y-3">
          <div>
            <span class="text-sm text-gray-500 block mb-1">Razon</span>
            <p class="text-sm text-gray-900 whitespace-pre-wrap">{{ selectedMovement.reason || 'Sin razon registrada' }}</p>
          </div>
          <div *ngIf="selectedMovement.notes">
            <span class="text-sm text-gray-500 block mb-1">Notas</span>
            <p class="text-sm text-gray-900 whitespace-pre-wrap">{{ selectedMovement.notes }}</p>
          </div>
        </div>
      </div>

      <!-- Boton ir a inscripcion -->
      <div class="pt-2">
        <a *ngIf="view === 'individual'"
          [routerLink]="['/dashboard/enrollments/view-v2', selectedMovement.enrollmentId]"
          target="_blank"
          class="w-full inline-flex items-center justify-center gap-2 bg-blue-600 text-white px-4 py-2.5 rounded-lg hover:bg-blue-700 transition font-medium text-sm">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
          </svg>
          Ver Inscripcion #{{ selectedMovement.enrollmentId }}
        </a>
        <a *ngIf="view === 'corporate'"
          [routerLink]="['/dashboard/enrollments/corporate/view-v2', selectedMovement.corporateEnrollmentId]"
          target="_blank"
          class="w-full inline-flex items-center justify-center gap-2 bg-amber-600 text-white px-4 py-2.5 rounded-lg hover:bg-amber-700 transition font-medium text-sm">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
          </svg>
          Ver Inscripcion Corporativa #{{ selectedMovement.corporateEnrollmentId }}
        </a>
      </div>

    </div>
  </div>
</div>
